<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import 'assets/scss/style';

 @import '~vue-loading-overlay/dist/vue-loading.css';
  @import '~vue-material-design-icons/styles.css';
  @import "~vue-select/src/scss/vue-select.scss";




</style>

<style>
@media print {
  @page {
    size: landscape;
    margin: 1cm; /* Optional: reduce margins to gain more space */
  }
  /* 1. Hide the whole body */
  body * {
    visibility: hidden;
  }

  /* 2. Show only the printable area */
  #printable-area, #printable-area * {
    visibility: visible;
  }

  /* 3. Position the printable area at the absolute top-left */
  #printable-area {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    background-color: white; /* Ensure background is white */
    zoom: 75%;
  }

  /* Optional: Force table borders to be black for better print contrast */
  ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
  ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    border-color: black !important;
    color: black !important;
  }
}
</style>
